import { cn } from "@/lib/cn";

/**
 * Maps every invoice status to a semantic, token-driven color.
 * Colors come from --status-* tokens, so look packs can restyle them centrally.
 */
const STATUS = {
  Draft: { label: "Draft", color: "draft" },
  Sent: { label: "Sent", color: "sent" },
  Paid: { label: "Paid", color: "paid" },
  PartiallyPaid: { label: "Partially Paid", color: "partial" },
  Superseded: { label: "Superseded", color: "superseded" },
  Void: { label: "Void", color: "void" },
};

const COLOR_CLASSES = {
  draft: "text-status-draft border-status-draft/30 bg-status-draft/10",
  sent: "text-status-sent border-status-sent/30 bg-status-sent/10",
  paid: "text-status-paid border-status-paid/30 bg-status-paid/10",
  partial: "text-status-partial border-status-partial/30 bg-status-partial/10",
  superseded: "text-status-superseded border-status-superseded/30 bg-status-superseded/10",
  void: "text-status-void border-status-void/30 bg-status-void/10",
};

export function StatusBadge({ status, className }) {
  const meta = STATUS[status] || STATUS.Draft;
  return (
    <span
      data-testid={`status-badge-${meta.color}`}
      className={cn(
        "inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 " +
          "text-xs font-medium font-sans",
        COLOR_CLASSES[meta.color],
        meta.color === "superseded" && "line-through decoration-1",
        className
      )}
    >
      {meta.label}
    </span>
  );
}
